/** In-app mark (docs/spec/06 §1 logo, cropped to viewBox 96 152 320 260). */
export function Logo({ width = 22 }: { width?: number }) {
  return (
    <svg width={width} height={(width * 260) / 320} viewBox="96 152 320 260" aria-hidden>
      <path d="M152 300 L256 206 L360 300 L360 392 L152 392 Z" fill="#FFB547" opacity="0.16" />
      <path
        d="M116 300 L256 172 L396 300"
        fill="none"
        stroke="#FFB547"
        strokeWidth="28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
